import React from "react";
import "../css/brochure.css";
import contact from "../../../../data/layouts/contact";

const Brochure = ({ data }) => {
  return (
    <section
      className="brochure m-0 py-5 lazy-bg skeleton loaded"
      id="brochure"
      style={{
        backgroundImage: 'url("./images/Section02-01-8.png")',
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="right-bg">
        <div className="container">
          <div className="wrap">
            <div className="row">
              <div className="brochure-left col-lg-6 col-12">
                <div className="brochure-video mt-lg-5 mb-3 lazy-bg skeleton loaded">
                  {/* FIX: video -> ảnh */}
                  <div
                    className="video-thumbnail"
                    style={{
                      backgroundImage: `url("${data?.imageUrl}")`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                  />
                </div>
              </div>

              <div className=" brochure-right col-lg-6 col-12">
                <div className="ps-lg-5 ms-lg-3 right">
                  <h1 className="default-box-title">{contact.name}</h1>
                  <p className="slogan">
                    <strong>
                      Công ty TNHH Nông Dược Miền Nam là công ty kinh doanh
                      thuốc bảo vệ thực vật, mạng lưới phân phối trên toàn quốc
                    </strong>
                  </p>

                  {/* FIX: nội dung lấy từ data.description thay cho đoạn Quote */}
                  <div className="larry-page-quote position-relative">
                    <div className="quote">{data?.description || ""}</div>
                    <strong className="position-absolute">
                      Nông Dược Miền Nam
                    </strong>
                  </div>

                  <div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Brochure;
